import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ClientsMissingRecipientsQuery } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_CLIENTS_MISSING_RECIPIENTS = gql`
    query clientsMissingRecipients {
        clientsNotificationsNoRecipients {
            nodes {
                name
                id
                statusCode
                lastModifiedBy
                lastModifiedByName
                lastModifiedTime
            }
        }
    }
`;

export const queryClientsMissingRecipients = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<ClientsMissingRecipientsQuery>({
        query: QUERY_CLIENTS_MISSING_RECIPIENTS,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.clientsNotificationsNoRecipients?.nodes;
};